'use client';
import { Promocodes } from '_shared';
import {
  SubscriptionForm,
  SubscriptionSuccess,
} from 'components/subscription/components';
import { Spacer, Typo } from 'components/ui-kit';
import { SubscriptionTag, carrotService } from 'lib';
import { useState } from 'react';
import styles from './subscribe.module.scss';

const handleSubscribe = async (email: string): Promise<void> => {
  return carrotService.subscribePromo(email, SubscriptionTag.MENU_10_SALE);
};

export const Subscribe = (): JSX.Element => {
  const [isCompleted, setIsCompleted] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {isCompleted ? (
          <SubscriptionSuccess promocode={Promocodes.SUBSCRIBE10} />
        ) : (
          <>
            <div className={styles.title}>
              Дарим скидку 10% за подписку на рассылку
            </div>
            <Spacer size={16} />
            <Typo>
              В&nbsp;ней мы&nbsp;рассказываем о&nbsp;лимитированных коллекциях,
              делимся интервью с интересными людьми и&nbsp;рассказываем
              о&nbsp;спецпредложениях и&nbsp;распродажах. Вся рассылка только
              по&nbsp;случаю и&nbsp;без спама.
            </Typo>
            <Spacer size={32} />
            <SubscriptionForm
              afterSubscribedHandler={() => setIsCompleted(true)}
              onSubscribe={handleSubscribe}
            />
          </>
        )}
      </div>
    </div>
  );
};
